import React, {useState} from 'react';

import Checkbox from '../../../CoreWrappers/Checkbox';

const NORMAL = 'normal';

const CheckboxDrydock = () => {
	const [values, setValues] = useState({
		[NORMAL]: false
	});

	const handleChange = (id, newValue) => setValues({...values, [id]: newValue});

	const renderCheckbox = () => {
		const id = NORMAL;
		const props = {
			id,
			name: 'sarasa',
			checked: values[id],
			onChange: () => handleChange(id, !values[id]),
			label: 'Checkbox label'
		};

		return <Checkbox {...props} />;
	};

	const renderCheckboxNoLabel = () => {
		const id = NORMAL;
		const props = {
			id,
			name: 'sarasa',
			checked: values[id],
			onChange: () => handleChange(id, !values[id])
		};

		return <Checkbox {...props} />;
	};

	return <>{renderCheckbox()}{renderCheckboxNoLabel()}</>;
};

export default CheckboxDrydock;
